import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: 'New UK Gambling Regulations Take Effect: What Players Need to Know',
      excerpt: 'Recent changes to UK gambling laws introduce stricter affordability checks and enhanced player protection measures. Here\'s how these updates affect your casino experience.',
      date: '01.12.2025',
      link: '/news/new-uk-gambling-regulations'
    },
    {
      id: 2,
      title: 'Top 5 Slot Games Paying Out Big This Month',
      excerpt: 'We\'ve tracked the highest-paying slots across UK casinos this month. These titles are delivering impressive RTP rates and frequent big wins to players.',
      date: '28.11.2025',
      link: '/news/top-5-slot-games-december'
    },
    {
      id: 3,
      title: 'Live Dealer Games: The Future of Online Casino Entertainment',
      excerpt: 'Live dealer technology continues to evolve, bringing authentic casino floor experiences directly to your screen. Discover which operators are leading the innovation.',
      date: '25.11.2025',
      link: '/news/live-dealer-games-future'
    }
  ];

  return (
    <section id="news" className="py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Latest Casino News
          </h2>
          <p className="text-gray-400 text-lg">
            Stay updated with the latest developments in the UK online casino industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <article
              key={item.id}
              itemScope
              itemType="https://schema.org/NewsArticle"
              className={`bg-gradient-to-br ${
                index === 0
                  ? 'from-toxic-orange/20 to-dark-black border-2 border-toxic-orange/30'
                  : 'from-gray-900 to-dark-black border border-gray-800'
              } rounded-xl p-6 hover:border-toxic-orange transition-all duration-300`}
            >
              <div className="w-full h-48 bg-gray-800 rounded-lg mb-4 overflow-hidden border border-gray-700">
                <img 
                  src={`/images/${index === 0 ? 'milos-tomasevic-f0QATZfOTv8-unsplash.webp' : index === 1 ? 'nemo-Fu4cSc9Gsp0-unsplash.webp' : 'paige-laine-elmer-2zTtKmIDUXc-unsplash.webp'}`} 
                  alt={item.title} 
                  className="w-full h-full object-cover"
                  itemProp="image"
                />
              </div>
              
              <div className="flex items-center gap-2 text-gray-400 text-sm mb-4">
                <Calendar size={16} className="text-toxic-orange" />
                <time dateTime={item.date.split('.').reverse().join('-')} itemProp="datePublished">{item.date}</time>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3 leading-tight" itemProp="headline">
                {item.title}
              </h3>
              
              <p className="text-gray-300 text-sm leading-relaxed mb-4" itemProp="description">
                {item.excerpt}
              </p>
              
              <Link
                to={item.link}
                data-discover="true"
                className="inline-flex items-center text-toxic-orange font-semibold hover:text-orange-400 transition-colors group text-sm"
              >
                Read More
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/news"
            data-discover="true"
            className="inline-flex items-center text-toxic-orange font-semibold hover:text-orange-400 transition-colors"
          >
            View All News
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default News;

